import { useCallback, useContext, useMemo } from 'react'
import {
  Title,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalCloseButton,
  Body,
  Link
} from '@panwds/react-ui'
import GlobalContext from '../../common/context/GlobalContext'
import { actions } from '@sparky/framework'

import type { VFC } from 'react'
import type { RenderModalProps } from '@panwds/react-ui'
import { VIEW_MANAGE_TENANT } from './common/GlobalConstants'

type AssociatedTenantModalProps = {
  associatedTenants: {
    [key: string]: {
      tsg_id: string
      [key: string]: any
    }
  }
}

const TITLE = 'Associated Tenant'

const AssociatedTenantModal: VFC<RenderModalProps & AssociatedTenantModalProps> = (props) => {
  const { isOpen, closeModal, associatedTenants } = props
  const { treeReducer = {} } = useContext(GlobalContext)
  const { sgKeyBy } = treeReducer

  const jump = useCallback(async (tsg_id: string) => {
    await actions.openCommonModule(VIEW_MANAGE_TENANT, tsg_id)
    closeModal()
    await actions.switchTsg(tsg_id)
  }, [closeModal])

  const [tenantDisplay, noAccessTsgs] = useMemo(() => {
    const noAccessTsgs: string[] = []
    const tenantDisplay = Object.values(associatedTenants).filter(each => {
      if (sgKeyBy[each.tsg_id]) {
        return true
      }
      noAccessTsgs.push(each.tsg_id)
      return false
    }).map((each, index) => {
      return (
        <Link key={index} onClick={() => jump(each.tsg_id)}
        >
          {`${sgKeyBy[each.tsg_id].display_name}`}
        </Link>
      )
    })
    return [tenantDisplay, noAccessTsgs]
  }, [associatedTenants, jump, sgKeyBy])
  return (
    <Modal size='md' confirmClose={false} onClose={closeModal} isOpen={isOpen}>
      <ModalHeader title={TITLE} enableClose />
      <ModalBody addClassName='cm-overflow-auto cm-scrollbar-default dark:cm-scrollbar-track-dark dark:cm-scrollbar-thumb-dark'>
        <Body as='div' addClassName='cm-flex cm-flex-col'>
          <Title level={2} size='xxs' addClassName='cm-mb-2'>Tenant(s) count: {Object.values(associatedTenants).length}</Title>
          {tenantDisplay}
          {Boolean(noAccessTsgs.length) && `There's ${noAccessTsgs.length} Tenants that you don't have access with, please contact your admin to provide access if you want to view it here.`}
        </Body>
      </ModalBody>
      <ModalFooter>
        <ModalCloseButton>Close</ModalCloseButton>
      </ModalFooter>
    </Modal>
  )
}

export default AssociatedTenantModal
